import { Navigate } from '@sorare/routing';

import { ANY_SPORT_MARKET_WATCHLISTS_FAVORITES } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const RedirectToFavoritesPage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MARKET_WATCHLISTS_FAVORITES)}
    />
  );
};

export default RedirectToFavoritesPage;
